import React from 'react';
import { Typography } from '@mui/material';

const RadioLink = ({ link, subtitle }) => {
  return (
    <a href={link} target="_blank" rel="noreferrer">
      <Typography variant="subtitle" sx={{ color: '#222AE0' }}>
        {subtitle}
      </Typography>
    </a>
  );
};

export default RadioLink;
